/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LayerType = {
    BackgroundImage: 'BackgroundImage',
    TextOverlay: 'TextOverlay',
    ComponentWidget: 'ComponentWidget'
} as const;
export type LayerType = typeof LayerType[keyof typeof LayerType];

